import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Table, Button, Badge } from "react-bootstrap";
import { Award, Download, RefreshCw, UserCheck } from "react-feather";
import * as XLSX from "xlsx";

function BrokerPerformanceReport() {
  const [data, setData] = useState([
    { id: 1, BrokerName: "Sharma & Associates", Station: "Indore", TotalTrades: 42, TotalQty: 24500, TotalValue: 127400000, TotalDalaliPaid: 122500, SharePercent: 38.5 },
    { id: 2, BrokerName: "Khandelwal Broking Co", Station: "Mumbai", TotalTrades: 28, TotalQty: 18200, TotalValue: 94640000, TotalDalaliPaid: 91000, SharePercent: 28.6 },
    { id: 3, BrokerName: "Gupta Commercial Agency", Station: "Nagpur", TotalTrades: 19, TotalQty: 12100, TotalValue: 62920000, TotalDalaliPaid: 60500, SharePercent: 19.0 },
    { id: 4, BrokerName: "Direct / No Broker", Station: "Local", TotalTrades: 12, TotalQty: 8800, TotalValue: 45760000, TotalDalaliPaid: 0, SharePercent: 13.9 },
  ]);

  const totalVolume = data.reduce((acc, r) => acc + r.TotalQty, 0);
  const totalCommission = data.reduce((acc, r) => acc + r.TotalDalaliPaid, 0);

  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "BrokerPerformance");
    XLSX.writeFile(wb, `Broker_Performance_${new Date().toISOString().split("T")[0]}.xlsx`);
  };

  return (
    <div className="page-content" style={{ padding: "15px" }}>
      <Container fluid>
        <Row className="mb-2 align-items-center">
          <Col xs={12} md={6}>
            <h5 className="mb-0 fw-bold text-dark d-flex align-items-center">
              <Award className="me-2 text-warning" size={22} />
              Broker Performance & Commission Summary (दलाल परफॉरमेंस व कमीशन समरी)
            </h5>
            <small className="text-muted">Analyze business volume, market share %, and commission paid to brokers</small>
          </Col>
          <Col xs={12} md={6} className="text-md-end mt-2 mt-md-0 d-flex justify-content-md-end gap-2">
            <Button size="sm" variant="success" onClick={exportToExcel}>
              <Download size={14} className="me-1" /> Excel
            </Button>
          </Col>
        </Row>

        <Card className="shadow-sm border-0">
          <Card.Body className="p-0">
            <Table responsive hover striped bordered className="mb-0 text-center align-middle" style={{ fontSize: "0.85rem" }}>
              <thead className="table-dark">
                <tr>
                  <th>Broker Name</th>
                  <th>Station</th>
                  <th>Total Deals</th>
                  <th>Total Volume (Qtl)</th>
                  <th>Total Trade Value (₹)</th>
                  <th>Total Dalali Paid (₹)</th>
                  <th>Business Share (%)</th>
                </tr>
              </thead>
              <tbody>
                {data.map((row) => (
                  <tr key={row.id}>
                    <td className="text-start ps-3 fw-bold">{row.BrokerName}</td>
                    <td>{row.Station}</td>
                    <td>{row.TotalTrades}</td>
                    <td className="fw-bold">{row.TotalQty.toLocaleString("en-IN")}</td>
                    <td>₹ {row.TotalValue.toLocaleString("en-IN")}</td>
                    <td className="text-primary fw-bold">₹ {row.TotalDalaliPaid.toLocaleString("en-IN")}</td>
                    <td>
                      <Badge bg="info" text="dark" className="fs-7 p-2">
                        {row.SharePercent}%
                      </Badge>
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot className="table-light fw-bold">
                <tr>
                  <td colSpan={3} className="text-end pe-3">Totals:</td>
                  <td>{totalVolume.toLocaleString("en-IN")} Qtl</td>
                  <td></td>
                  <td className="text-primary fs-6">₹ {totalCommission.toLocaleString("en-IN")}</td>
                  <td>100.0%</td>
                </tr>
              </tfoot>
            </Table>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
}

export default BrokerPerformanceReport;
